const autoNgTemplateLoaderTemplate1 = require('./license-node-panel.html');

import controller from './license-node-panel.controller.js';

export const licenseNodePanel = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
